var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-78 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff706a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#f64640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f43b36"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 177.634352,
    x2: 177.634352,
    xlinkHref: "#a",
    y1: 188.635939878,
    y2: 217.9754599358
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 166.8461057958,
    x2: 188.4225982042,
    y1: 18.3930557464,
    y2: 96.1274389518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3251"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3e843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#a9c93c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8db437"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 174.0704289,
    x2: 181.1982751,
    xlinkHref: "#d",
    y1: 0.4820833444,
    y2: 26.1615045746
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8567,
    stopColor: "#0b9cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d94fe"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 140.5721619572,
    x2: 226.4569863118,
    xlinkHref: "#f",
    y1: 87.8434761766,
    y2: 173.7283005312
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d94fe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5142,
    stopColor: "#0681cd",
    stopOpacity: 0.513725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070a2"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 174.0525590884,
    x2: 136.5310747306,
    xlinkHref: "#h",
    y1: 139.8806687324,
    y2: 102.3591843746
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 244.0991084022,
    x2: 208.7812328344,
    xlinkHref: "#h",
    y1: 132.6894750542,
    y2: 97.3715994864
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2296,
    stopColor: "#ffd355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4362,
    stopColor: "#ffcf4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb400"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 143.4177357732,
    x2: 162.4641439572,
    xlinkHref: "#k",
    y1: 107.8044058524,
    y2: 126.8509144286
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396,
    stopColor: "#e27f04",
    stopOpacity: 0.039216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#c15d2f",
    stopOpacity: 0.466667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 159.9611083276,
    x2: 118.807534566,
    xlinkHref: "#m",
    y1: 124.3481883328,
    y2: 83.194514179
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 130.8974229424,
    x2: 145.171487115,
    xlinkHref: "#a",
    y1: 89.0061671868,
    y2: 114.3310031666
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0013,
    stopColor: "#e7eeed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#eef3f2",
    stopOpacity: 0.427451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 139.0067613554,
    x2: 139.0067613554,
    xlinkHref: "#p",
    y1: 105.7616775616,
    y2: 74.5477347376
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 220.6737501456,
    x2: 239.7202587218,
    xlinkHref: "#k",
    y1: 107.8044058524,
    y2: 126.8509144286
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 237.2172230922,
    x2: 196.0636493306,
    xlinkHref: "#m",
    y1: 124.3481883328,
    y2: 83.194514179
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 208.1534373148,
    x2: 222.4275014874,
    xlinkHref: "#a",
    y1: 89.0061671868,
    y2: 114.3310031666
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 216.26287612,
    x2: 216.26287612,
    xlinkHref: "#p",
    y1: 105.7616775616,
    y2: 74.5477347376
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 235.2090779156,
    x2: 142.039795529,
    xlinkHref: "#h",
    y1: 220.5243175016,
    y2: 127.3549347228
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 167.169469072,
    x2: 216.969019882,
    xlinkHref: "#w",
    y1: 152.484708658,
    y2: 202.284259468
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 126.6212602764,
    x2: 137.8352698008,
    xlinkHref: "#w",
    y1: 159.4651791084,
    y2: 167.4031903624
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 135.8239120738,
    x2: 150.3278743844,
    xlinkHref: "#w",
    y1: 158.45402887,
    y2: 168.7208379874
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 152.2216728452,
    x2: 166.7283457452,
    xlinkHref: "#w",
    y1: 158.4527237714,
    y2: 168.7215407328
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 168.6252563642,
    x2: 183.1320296564,
    xlinkHref: "#w",
    y1: 158.4527237714,
    y2: 168.721641125
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 185.0289402754,
    x2: 199.5357135676,
    xlinkHref: "#w",
    y1: 158.4527237714,
    y2: 168.7215407328
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 201.4301143816,
    x2: 215.9340766922,
    xlinkHref: "#w",
    y1: 158.45402887,
    y2: 168.7208379874
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 215.8053738918,
    x2: 228.2960710236,
    xlinkHref: "#w",
    y1: 159.7734835546,
    y2: 168.615225393
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 25.4600560244,
    x2: 39.0590830442,
    xlinkHref: "#a",
    y1: 123.1753062602,
    y2: 136.77433328
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientTransform: "matrix(0 1.003922 -1.003922 0 445.009978 344.704502)",
    gradientUnits: "userSpaceOnUse",
    x1: -117.7112,
    x2: -83.0648,
    xlinkHref: "#f",
    y1: 367.6072,
    y2: 367.6072
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 16.270455213,
    x2: 51.0526380016,
    xlinkHref: "#f",
    y1: 178.1522836086,
    y2: 178.1522836086
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1917,
    stopColor: "#ffd254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    stopColor: "#ffcd46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    stopColor: "#ffc52e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9103,
    stopColor: "#ffb90e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb400"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 13.565387384,
    x2: 54.3280339188,
    xlinkHref: "#I",
    y1: 242.2645495882,
    y2: 242.2645495882
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientTransform: "matrix(-.709873 -.709873 .709873 -.709873 -209.862618 705.389829)",
    gradientUnits: "userSpaceOnUse",
    x1: 144.0429,
    x2: 170.1308,
    xlinkHref: "#I",
    y1: 496.5567,
    y2: 496.5567
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 17.78989116,
    x2: 47.3781830894,
    xlinkHref: "#d",
    y1: 82.538953113,
    y2: 112.1271446502
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 316.722048438,
    x2: 330.3210754578,
    xlinkHref: "#a",
    y1: 123.1753062602,
    y2: 136.77433328
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientTransform: "matrix(0 1.003922 1.003922 0 -380.460415 344.704502)",
    gradientUnits: "userSpaceOnUse",
    x1: -117.7112,
    x2: -83.0648,
    xlinkHref: "#f",
    y1: 657.1905,
    y2: 657.1905
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 293.9338968744,
    x2: 233.9057863752,
    xlinkHref: "#h",
    y1: 277.7893334802,
    y2: 217.761222981
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 307.5324476266,
    x2: 342.3146304152,
    xlinkHref: "#f",
    y1: 178.1522836086,
    y2: 178.1522836086
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 142.915321 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -198.0113,
    x2: -157.4079,
    xlinkHref: "#I",
    y1: 241.3181,
    y2: 241.3181
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientTransform: "matrix(.709873 -.709873 -.709873 -.709873 274.412181 705.389829)",
    gradientUnits: "userSpaceOnUse",
    x1: 348.8091,
    x2: 374.8971,
    xlinkHref: "#I",
    y1: 291.7904,
    y2: 291.7904
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0518835736,
    x2: 338.640175503,
    xlinkHref: "#d",
    y1: 82.538953113,
    y2: 112.1271446502
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 132.9908441898,
    x2: 155.2041243228,
    xlinkHref: "#I",
    y1: 393.9243355388,
    y2: 413.9163378546
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 318.769351 897.683376)",
    gradientUnits: "userSpaceOnUse",
    x1: 168.8714,
    x2: 183.2004,
    xlinkHref: "#I",
    y1: 487.228,
    y2: 500.1241
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 145.5144699632,
    x2: 139.5498681846,
    xlinkHref: "#m",
    y1: 409.3636519768,
    y2: 373.0986763942
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 122.8753261178,
    x2: 167.5669217918,
    xlinkHref: "#f",
    y1: 335.7902242848,
    y2: 376.0126603914
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 129.7308082792,
    x2: 171.2040308056,
    xlinkHref: "#f",
    y1: 441.351217094,
    y2: 482.8244396204
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 133.3415141444,
    x2: 163.4008462762,
    xlinkHref: "#d",
    y1: 487.7209687832,
    y2: 517.7802005228
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 319.437862 772.207937)",
    gradientUnits: "userSpaceOnUse",
    x1: 166.9014,
    x2: 187.1688,
    xlinkHref: "#f",
    y1: 401.0643,
    y2: 419.305
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    gradientUnits: "userSpaceOnUse",
    x1: 164.4220357346,
    x2: 114.476615058,
    xlinkHref: "#h",
    y1: 365.1486180762,
    y2: 315.2031973996
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    gradientUnits: "userSpaceOnUse",
    x1: 202.558221533,
    x2: 224.771501666,
    xlinkHref: "#I",
    y1: 393.9243355388,
    y2: 413.9163378546
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 318.769351 897.683376)",
    gradientUnits: "userSpaceOnUse",
    x1: 99.5758,
    x2: 113.9048,
    xlinkHref: "#I",
    y1: 487.228,
    y2: 500.1241
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    gradientUnits: "userSpaceOnUse",
    x1: 215.0818473064,
    x2: 209.1172455278,
    xlinkHref: "#m",
    y1: 409.3636519768,
    y2: 373.0986763942
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    gradientUnits: "userSpaceOnUse",
    x1: 192.442703461,
    x2: 237.134299135,
    xlinkHref: "#f",
    y1: 335.7902242848,
    y2: 376.0126603914
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    gradientUnits: "userSpaceOnUse",
    x1: 199.2981856224,
    x2: 240.7714081488,
    xlinkHref: "#f",
    y1: 441.351217094,
    y2: 482.8244396204
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    gradientUnits: "userSpaceOnUse",
    x1: 202.9088914876,
    x2: 232.9682236194,
    xlinkHref: "#d",
    y1: 487.7209687832,
    y2: 517.7802005228
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 319.437862 772.207937)",
    gradientUnits: "userSpaceOnUse",
    x1: 97.6058,
    x2: 117.8732,
    xlinkHref: "#f",
    y1: 401.0643,
    y2: 419.305
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    gradientUnits: "userSpaceOnUse",
    x1: 233.9894130778,
    x2: 184.0439924012,
    xlinkHref: "#h",
    y1: 365.1486180762,
    y2: 315.2031973996
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    gradientUnits: "userSpaceOnUse",
    x1: 159.9595020524,
    x2: 122.3360192194,
    xlinkHref: "#h",
    y1: 347.9414953884,
    y2: 287.8522460394
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    gradientUnits: "userSpaceOnUse",
    x1: 229.5268793956,
    x2: 191.9034969548,
    xlinkHref: "#h",
    y1: 347.9414953884,
    y2: 287.8522460394
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    gradientUnits: "userSpaceOnUse",
    x1: 135.558977058,
    x2: 225.462701963,
    xlinkHref: "#f",
    y1: 225.5588859394,
    y2: 315.4627112366
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 436.268633 961.481788)",
    gradientUnits: "userSpaceOnUse",
    x1: 255.1692,
    x2: 260.612,
    xlinkHref: "#f",
    y1: 641.7144,
    y2: 653.9977
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    gradientUnits: "userSpaceOnUse",
    x1: 252.1229549872,
    x2: 147.6141728262,
    xlinkHref: "#h",
    y1: 332.3883341956,
    y2: 227.8795520346
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    gradientUnits: "userSpaceOnUse",
    x1: 158.7709587966,
    x2: 201.0439055882,
    xlinkHref: "#f",
    y1: 239.0364383972,
    y2: 281.3093851888
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    gradientUnits: "userSpaceOnUse",
    x1: 162.0933382634,
    x2: 143.1125865782,
    xlinkHref: "#h",
    y1: 257.5739585194,
    y2: 238.5932068342
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    gradientUnits: "userSpaceOnUse",
    x1: 226.835565298,
    x2: 207.854914005,
    xlinkHref: "#h",
    y1: 257.5739585194,
    y2: 238.5932068342
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    gradientUnits: "userSpaceOnUse",
    x1: 194.4644015846,
    x2: 175.4837502916,
    xlinkHref: "#h",
    y1: 257.5739585194,
    y2: 238.5932068342
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    gradientUnits: "userSpaceOnUse",
    x1: 140.1420386794,
    x2: 149.1567562784,
    xlinkHref: "#d",
    y1: 231.657560247,
    y2: 247.65154359
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    gradientUnits: "userSpaceOnUse",
    x1: 172.5132023928,
    x2: 181.5279199918,
    xlinkHref: "#I",
    y1: 231.657560247,
    y2: 247.65154359
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    gradientUnits: "userSpaceOnUse",
    x1: 204.8843661062,
    x2: 213.8990837052,
    xlinkHref: "#a",
    y1: 231.657560247,
    y2: 247.65154359
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m150.394531 198.695312h54.480469v23.050782h-54.480469zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m173.757812 16.472656h7.753907v81.574219h-7.753907zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m190.957031 13.320312c0 7.359376-5.964843 13.324219-13.324219 13.324219-7.355468 0-13.320312-5.964843-13.320312-13.324219 0-7.355468 5.964844-13.320312 13.320312-13.320312 7.359376 0 13.324219 5.964844 13.324219 13.320312zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m232.167969 204.367188h-109.066407c-13.769531 0-24.929687-11.160157-24.929687-24.929688v-109.066406c0-13.765625 11.160156-24.925782 24.929687-24.925782h109.066407c13.769531 0 24.929687 11.160157 24.929687 24.925782v109.070312c-.003906 13.765625-11.164062 24.925782-24.929687 24.925782zm0 0",
    fill: "url(#g)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m255.296875 188.734375c-3.679687 9.167969-12.648437 15.636719-23.128906 15.636719h-25.988281c-36.253907-36.246094-83.597657-83.578125-83.597657-83.578125l-.058593-.058594c-.140626-.132813-.273438-.269531-.417969-.410156-.421875-.417969-.816407-.839844-1.199219-1.292969-.21875-.257812-.425781-.507812-.636719-.773438-.582031-.746093-1.132812-1.527343-1.625-2.355468-.101562-.160156-.191406-.308594-.285156-.464844-.191406-.34375-.382813-.683594-.558594-1.042969-.09375-.167969-.175781-.335937-.257812-.511719-.085938-.175781-.167969-.347656-.242188-.523437-1.371093-2.980469-2.121093-6.300781-2.121093-9.796875 0-3.488281.742187-6.792969 2.085937-9.769531 1.542969-3.429688 3.882813-6.417969 6.765625-8.753907h27.484375zm0 0",
    fill: "url(#i)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m257.101562 113.316406v64.714844c-25.867187-25.851562-57.265624-57.238281-57.265624-57.238281-.015626-.015625-.03125-.035157-.058594-.058594-.140625-.132813-.273438-.265625-.417969-.410156-.414063-.414063-.816406-.839844-1.191406-1.292969-.21875-.257812-.425781-.507812-.636719-.773438-.589844-.742187-1.132812-1.527343-1.632812-2.355468-.101563-.15625-.183594-.308594-.277344-.464844-.199219-.34375-.390625-.683594-.566406-1.042969-.089844-.167969-.175782-.332031-.257813-.507812s-.160156-.351563-.242187-.527344c-1.359376-2.980469-2.121094-6.300781-2.121094-9.796875 0-3.488281.746094-6.789062 2.085937-9.769531 1.546875-3.429688 3.882813-6.414063 6.777344-8.75h27.476563zm0 0",
    fill: "url(#j)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m162.832031 103.394531c0 13.15625-10.667969 23.824219-23.824219 23.824219-13.160156 0-23.828124-10.667969-23.828124-23.824219 0-13.160156 10.667968-23.828125 23.828124-23.828125 13.15625 0 23.824219 10.667969 23.824219 23.828125zm0 0",
    fill: "url(#l)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m162.832031 103.394531c0-.605469-.046875-1.199219-.089843-1.792969l-10.703126-10.707031c-3.289062-3.425781-7.90625-5.570312-13.03125-5.570312-9.980468 0-18.070312 8.089843-18.070312 18.066406 0 5.125 2.144531 9.742187 5.570312 13.03125l10.707032 10.707031c.59375.042969 1.1875.089844 1.792968.089844 13.15625 0 23.824219-10.667969 23.824219-23.824219zm0 0",
    fill: "url(#n)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m157.074219 103.394531c0 9.976563-8.089844 18.066407-18.066407 18.066407-9.980468 0-18.070312-8.089844-18.070312-18.066407 0-9.980469 8.089844-18.070312 18.070312-18.070312 9.976563 0 18.066407 8.089843 18.066407 18.070312zm0 0",
    fill: "url(#o)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m152.167969 99.074219c0-6.296875-5.890625-11.398438-13.160157-11.398438-7.269531 0-13.164062 5.101563-13.164062 11.398438s5.894531 11.398437 13.164062 11.398437c7.269532 0 13.160157-5.101562 13.160157-11.398437zm0 0",
    fill: "url(#q)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m240.089844 103.394531c0 13.15625-10.667969 23.824219-23.828125 23.824219-13.160157 0-23.824219-10.667969-23.824219-23.824219 0-13.160156 10.664062-23.828125 23.824219-23.828125 13.160156 0 23.828125 10.667969 23.828125 23.828125zm0 0",
    fill: "url(#r)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m240.089844 103.394531c0-.605469-.046875-1.199219-.09375-1.792969l-10.703125-10.707031c-3.289063-3.425781-7.90625-5.570312-13.03125-5.570312-9.980469 0-18.066407 8.089843-18.066407 18.066406 0 5.125 2.140626 9.742187 5.570313 13.03125l10.703125 10.707031c.59375.042969 1.1875.089844 1.792969.089844 13.160156 0 23.828125-10.667969 23.828125-23.824219zm0 0",
    fill: "url(#s)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m234.332031 103.394531c0 9.976563-8.089843 18.066407-18.070312 18.066407s-18.066407-8.089844-18.066407-18.066407c0-9.980469 8.085938-18.070312 18.066407-18.070312s18.070312 8.089843 18.070312 18.070312zm0 0",
    fill: "url(#t)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m229.425781 99.074219c0-6.296875-5.894531-11.398438-13.164062-11.398438s-13.160157 5.101563-13.160157 11.398438 5.890626 11.398437 13.160157 11.398437 13.164062-5.101562 13.164062-11.398437zm0 0",
    fill: "url(#u)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m232.167969 204.367188c13.769531 0 24.929687-11.160157 24.929687-24.929688v-16.285156l-18.1875-18.183594c-2.046875-2.285156-5.011718-3.726562-8.324218-3.726562h-102.144532c-6.183594 0-11.195312 5.011718-11.195312 11.195312v24.785156c0 3.308594 1.441406 6.273438 3.726562 8.320313l18.820313 18.824219zm0 0",
    fill: "url(#v)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m230.585938 188.417969h-102.144532c-6.183594 0-11.195312-5.011719-11.195312-11.195313v-24.785156c0-6.183594 5.011718-11.195312 11.195312-11.195312h102.144532c6.183593 0 11.195312 5.011718 11.195312 11.195312v24.785156c.003906 6.183594-5.011719 11.195313-11.195312 11.195313zm0 0",
    fill: "url(#x)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m136.632812 146.257812v37.144532h-1.917968c-5.117188 0-9.261719-4.144532-9.261719-9.253906v-18.636719c0-5.105469 4.148437-9.253907 9.261719-9.253907zm0 0",
    fill: "url(#y)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m136.632812 146.257812h16.394532v37.144532h-16.394532zm0 0",
    fill: "url(#z)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m153.027344 146.257812h16.40625v37.144532h-16.40625zm0 0",
    fill: "url(#A)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m169.433594 146.257812h16.402344v37.144532h-16.402344zm0 0",
    fill: "url(#B)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m185.835938 146.257812h16.402343v37.144532h-16.402343zm0 0",
    fill: "url(#C)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m202.238281 146.257812h16.394531v37.144532h-16.394531zm0 0",
    fill: "url(#D)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m233.570312 155.511719v18.636719c0 5.109374-4.140624 9.253906-9.253906 9.253906h-5.683594v-37.144532h5.683594c5.113282 0 9.253906 4.144532 9.253906 9.253907zm0 0",
    fill: "url(#E)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m23.945312 117.265625h16.117188v24.90625h-16.117188zm0 0",
    fill: "url(#F)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m39.722656 251.578125v-18.628906c0-7.355469 5.960938-13.316407 13.316406-13.316407h45.839844c7.359375 0 13.320313 5.960938 13.320313 13.316407v18.628906c0 7.355469-5.960938 13.320313-13.320313 13.320313h-45.839844c-7.355468 0-13.316406-5.964844-13.316406-13.320313zm0 0",
    fill: "url(#G)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m41.316406 224.09375h-18.625c-7.355468 0-13.320312-5.964844-13.320312-13.320312v-65.242188c0-7.355469 5.964844-13.320312 13.320312-13.320312h18.625c7.355469 0 13.320313 5.964843 13.320313 13.320312v65.242188c0 7.355468-5.964844 13.320312-13.320313 13.320312zm0 0",
    fill: "url(#H)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m58.527344 242.265625c0 14.648437-11.875 26.523437-26.523438 26.523437-14.648437 0-26.523437-11.875-26.523437-26.523437 0-14.652344 11.875-26.527344 26.523437-26.527344 14.648438 0 26.523438 11.875 26.523438 26.527344zm0 0",
    fill: "url(#J)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m49.046875 242.265625c0 9.410156-7.632813 17.042969-17.042969 17.042969-9.414062 0-17.042968-7.632813-17.042968-17.042969 0-9.414063 7.628906-17.042969 17.042968-17.042969 9.410156 0 17.042969 7.628906 17.042969 17.042969zm0 0",
    fill: "url(#K)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m50.234375 78.894531-2.578125 2.582031c-1.871094 1.867188-2.285156 4.730469-1.054688 7.070313 1.226563 2.332031 1.910157 4.988281 1.878907 7.8125-.097657 8.597656-7.007813 15.816406-15.589844 16.265625-9.503906.496094-17.363281-7.0625-17.363281-16.453125 0-2.769531.6875-5.375 1.898437-7.660156 1.242188-2.351563.710938-5.253907-1.171875-7.132813l-2.484375-2.484375c-2.8125-2.8125-7.503906-2.148437-9.496093 1.300781-2.882813 4.988282-4.457032 10.824219-4.257813 17.046876.535156 16.265624 13.492187 29.738281 29.726563 30.855468 18.699218 1.28125 34.265624-13.503906 34.265624-31.925781 0-5.875-1.585937-11.375-4.347656-16.101563-1.976562-3.386718-6.652344-3.945312-9.425781-1.175781zm0 0",
    fill: "url(#L)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m315.207031 117.265625h16.117188v24.90625h-16.117188zm0 0",
    fill: "url(#M)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m315.546875 251.578125v-18.628906c0-7.355469-5.964844-13.316407-13.320313-13.316407h-45.839843c-7.355469 0-13.316407 5.960938-13.316407 13.316407v18.628906c0 7.355469 5.960938 13.320313 13.316407 13.320313h45.839843c7.355469 0 13.320313-5.964844 13.320313-13.320313zm0 0",
    fill: "url(#N)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m256.386719 264.898438h45.839843c2.570313 0 4.957032-.738282 6.992188-1.996094l-43.097656-43.097656-.199219-.171876h-9.535156c-7.355469 0-13.316407 5.964844-13.316407 13.320313v18.625c-.003906 7.355469 5.960938 13.320313 13.316407 13.320313zm0 0",
    fill: "url(#O)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m332.578125 224.09375h-18.625c-7.355469 0-13.320313-5.964844-13.320313-13.320312v-65.242188c0-7.355469 5.964844-13.320312 13.320313-13.320312h18.625c7.355469 0 13.320313 5.964843 13.320313 13.320312v65.242188c0 7.355468-5.964844 13.320312-13.320313 13.320312zm0 0",
    fill: "url(#P)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m349.789062 242.265625c0 14.648437-11.875 26.523437-26.523437 26.523437s-26.523437-11.875-26.523437-26.523437c0-14.652344 11.875-26.527344 26.523437-26.527344s26.523437 11.875 26.523437 26.527344zm0 0",
    fill: "url(#Q)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m340.308594 242.265625c0 9.410156-7.632813 17.042969-17.042969 17.042969-9.414063 0-17.042969-7.632813-17.042969-17.042969 0-9.414063 7.628906-17.042969 17.042969-17.042969 9.410156 0 17.042969 7.628906 17.042969 17.042969zm0 0",
    fill: "url(#R)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m341.496094 78.894531-2.578125 2.582031c-1.871094 1.867188-2.285157 4.730469-1.054688 7.070313 1.226563 2.332031 1.910157 4.988281 1.878907 7.8125-.097657 8.597656-7.007813 15.816406-15.589844 16.265625-9.503906.496094-17.363282-7.0625-17.363282-16.453125 0-2.769531.6875-5.375 1.898438-7.660156 1.242188-2.351563.710938-5.253907-1.167969-7.132813l-2.488281-2.484375c-2.8125-2.8125-7.503906-2.148437-9.496094 1.300781-2.882812 4.988282-4.457031 10.824219-4.257812 17.046876.535156 16.265624 13.492187 29.738281 29.726562 30.855468 18.699219 1.28125 34.265625-13.503906 34.265625-31.925781 0-5.875-1.585937-11.375-4.347656-16.101563-1.976563-3.386718-6.652344-3.945312-9.425781-1.175781zm0 0",
    fill: "url(#S)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m124.820312 390.355469h36.058594v24.882812h-36.058594zm0 0",
    fill: "url(#T)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m135.121094 390.355469h15.460937v24.882812h-15.460937zm0 0",
    fill: "url(#U)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m124.820312 395.980469.160157.296875 18.964843 18.960937h16.9375v-24.882812h-36.0625zm0 0",
    fill: "url(#V)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m158.75 396.703125h-31.796875c-4.976563 0-9.011719-4.03125-9.011719-9.007813v-71.867187h49.820313v71.867187c0 4.976563-4.035157 9.007813-9.011719 9.007813zm0 0",
    fill: "url(#W)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m135.65625 411.394531h14.386719c9.785156 0 17.71875 7.929688 17.71875 17.714844v54.453125c0 4.808594-3.898438 8.707031-8.707031 8.707031h-32.410157c-4.804687 0-8.703125-3.898437-8.703125-8.707031v-54.453125c0-9.785156 7.929688-17.714844 17.714844-17.714844zm0 0",
    fill: "url(#X)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m165.117188 512h-44.535157c-6.289062 0-11.386719-5.097656-11.386719-11.390625v-6.757813c0-6.292968 5.097657-11.390624 11.386719-11.390624h44.535157c6.289062 0 11.390624 5.097656 11.390624 11.390624v6.757813c0 6.292969-5.101562 11.390625-11.390624 11.390625zm0 0",
    fill: "url(#Y)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m138.683594 339.601562h8.332031c3.65625 0 6.621094 2.960938 6.621094 6.617188v30.445312c0 3.65625-2.964844 6.621094-6.621094 6.621094h-8.332031c-3.65625 0-6.621094-2.964844-6.621094-6.621094v-30.445312c0-3.65625 2.964844-6.617188 6.621094-6.617188zm0 0",
    fill: "url(#Z)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m143.320312 396.703125h15.429688c4.976562 0 9.007812-4.03125 9.007812-9.007813v-71.867187h-24.441406v80.875zm0 0",
    fill: "url(#aa)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m194.386719 390.355469h36.0625v24.882812h-36.0625zm0 0",
    fill: "url(#ab)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m204.6875 390.355469h15.460938v24.882812h-15.460938zm0 0",
    fill: "url(#ac)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m194.386719 395.980469.164062.296875 18.960938 18.960937h16.9375v-24.882812h-36.0625zm0 0",
    fill: "url(#ad)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m228.316406 396.703125h-31.796875c-4.976562 0-9.011719-4.03125-9.011719-9.007813v-71.867187h49.820313v71.867187c0 4.976563-4.035156 9.007813-9.011719 9.007813zm0 0",
    fill: "url(#ae)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m205.222656 411.394531h14.390625c9.78125 0 17.714844 7.929688 17.714844 17.714844v54.453125c0 4.808594-3.898437 8.707031-8.707031 8.707031h-32.40625c-4.808594 0-8.707032-3.898437-8.707032-8.707031v-54.453125c0-9.785156 7.933594-17.714844 17.714844-17.714844zm0 0",
    fill: "url(#af)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m234.683594 512h-44.53125c-6.292969 0-11.390625-5.097656-11.390625-11.390625v-6.757813c0-6.292968 5.097656-11.390624 11.390625-11.390624h44.53125c6.292968 0 11.390625 5.097656 11.390625 11.390624v6.757813c0 6.292969-5.097657 11.390625-11.390625 11.390625zm0 0",
    fill: "url(#ag)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m208.25 339.601562h8.335938c3.65625 0 6.617187 2.960938 6.617187 6.617188v30.445312c0 3.65625-2.960937 6.621094-6.617187 6.621094h-8.335938c-3.65625 0-6.617188-2.964844-6.617188-6.621094v-30.445312c0-3.65625 2.960938-6.617188 6.617188-6.617188zm0 0",
    fill: "url(#ah)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m212.886719 396.703125h15.429687c4.976563 0 9.011719-4.03125 9.011719-9.007813v-71.867187h-24.441406zm0 0",
    fill: "url(#ai)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m117.941406 325.402344 49.820313 49.824218v-59.398437h-49.820313zm0 0",
    fill: "url(#aj)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m187.507812 325.402344 49.820313 49.824218v-59.398437h-49.820313zm0 0",
    fill: "url(#ak)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m250.664062 325.183594h-146.058593c-9.261719 0-16.769531-7.507813-16.769531-16.769532v-81.558593c0-9.261719 7.507812-16.769531 16.769531-16.769531h146.058593c9.257813 0 16.765626 7.507812 16.765626 16.769531v81.558593c0 9.261719-7.507813 16.769532-16.765626 16.769532zm0 0",
    fill: "url(#al)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m148.289062 304.535156h58.691407c3.949219 0 7.152343 3.203125 7.152343 7.152344 0 3.953125-3.203124 7.152344-7.152343 7.152344h-58.691407c-3.953124 0-7.15625-3.199219-7.15625-7.152344 0-3.949219 3.203126-7.152344 7.15625-7.152344zm0 0",
    fill: "url(#am)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m267.429688 308.414062v-47.988281l-36.796876-36.796875c-2.605468-2.902344-6.375-4.738281-10.585937-4.738281h-84.828125c-7.863281 0-14.242188 6.375-14.242188 14.242187v49.535157c0 4.207031 1.835938 7.976562 4.738282 10.585937l31.929687 31.929688h93.019531c9.257813 0 16.765626-7.507813 16.765626-16.769532zm0 0",
    fill: "url(#an)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m220.050781 296.910156h-84.832031c-7.863281 0-14.238281-6.378906-14.238281-14.242187v-49.535157c0-7.867187 6.375-14.242187 14.238281-14.242187h84.832031c7.863281 0 14.238281 6.375 14.238281 14.242187v49.535157c0 7.863281-6.375 14.242187-14.238281 14.242187zm0 0",
    fill: "url(#ao)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m180.742188 261.175781c0-.382812-.027344-.757812-.058594-1.132812l-27.191406-27.191407c-2.078126-2.164062-4.992188-3.519531-8.230469-3.519531-6.300781 0-11.410157 5.109375-11.410157 11.414063 0 3.234375 1.355469 6.152344 3.519532 8.226562l27.191406 27.191406c.375.03125.75.058594 1.132812.058594 8.308594 0 15.046876-6.738281 15.046876-15.046875zm0 0",
    fill: "url(#ap)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m245.484375 261.175781c0-.382812-.027344-.757812-.058594-1.132812l-27.191406-27.191407c-2.078125-2.164062-4.992187-3.519531-8.230469-3.519531-6.300781 0-11.410156 5.109375-11.410156 11.414063 0 3.234375 1.355469 6.152344 3.519531 8.226562l27.191407 27.191406c.375.03125.75.058594 1.128906.058594 8.3125 0 15.050781-6.738281 15.050781-15.046875zm0 0",
    fill: "url(#aq)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m213.113281 261.175781c0-.382812-.03125-.757812-.058593-1.132812l-27.191407-27.191407c-2.078125-2.164062-4.992187-3.519531-8.230469-3.519531-6.300781 0-11.410156 5.109375-11.410156 11.414063 0 3.234375 1.351563 6.152344 3.519532 8.226562l27.191406 27.191406c.375.03125.75.058594 1.128906.058594 8.3125 0 15.050781-6.738281 15.050781-15.046875zm0 0",
    fill: "url(#ar)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m156.675781 240.742188c0 6.304687-5.109375 11.414062-11.414062 11.414062-6.300781 0-11.410157-5.109375-11.410157-11.414062 0-6.300782 5.109376-11.410157 11.410157-11.410157 6.304687 0 11.414062 5.109375 11.414062 11.410157zm0 0",
    fill: "url(#as)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m189.046875 240.742188c0 6.304687-5.109375 11.414062-11.414063 11.414062-6.300781 0-11.410156-5.109375-11.410156-11.414062 0-6.300782 5.109375-11.410157 11.410156-11.410157 6.304688 0 11.414063 5.109375 11.414063 11.410157zm0 0",
    fill: "url(#at)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m221.417969 240.742188c0 6.304687-5.109375 11.414062-11.414063 11.414062-6.300781 0-11.410156-5.109375-11.410156-11.414062 0-6.300782 5.109375-11.410157 11.410156-11.410157 6.304688 0 11.414063 5.109375 11.414063 11.410157zm0 0",
    fill: "url(#au)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRobot);
export default __webpack_public_path__ + "static/media/icon-robot.aea3aefef69f93c13baf3af75087d373.svg";
export { ForwardRef as ReactComponent };